<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'assessment.confirmOtp.title' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="mat-typography">
    <form [formGroup]="confirmOTPForm" novalidate>
      <div class="form-wrapper">
        <div class="input-field">
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'assessment.confirmOtp.label' | translate}}</label>&nbsp;<span class="required">*</span>&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div class="confirmOTP">
              <input type="text" class="form-control" maxLength="4" formControlName="confirmOtp" (keydown)="onKeydown($event)" (keypress)="omit_special_char($event)"
                onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()">
              <div *ngIf="f.confirmOtp.invalid && (f.confirmOtp.dirty || f.confirmOtp.touched)" class="alert alert-danger">
                <div *ngIf="f.confirmOtp.errors?.required">{{'assessment.confirmOtp.errorMsg1' | translate}}</div>
              </div>
              <div class="alert alert-danger" *ngIf="errorMessage && f.confirmOtp.valid">{{errorMessage}}</div>
              <br>
              <div *ngIf="isEnable && isTimeShow">{{minutes}} {{'assessment.confirmOtp.min' | translate}} {{seconds}} {{'assessment.confirmOtp.sec' | translate}}</div>
              <div *ngIf="!isEnable" class="errorMessage">{{'assessment.confirmOtp.error' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button [disabled]="confirmOTPForm.invalid || !isEnable" (click)='onSubmit()' mat-raised-button class="btn-primary">{{'assessment.confirmOtp.submit' | translate}}</button>
  </mat-dialog-actions>
</div>
